import { AntDesign } from "@expo/vector-icons";
import { router } from "expo-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, Pressable, ScrollView } from "react-native";

import TitleXl from "@/components/TitleXl";
import { useAppSelector } from "@/context/hooks";
import { renderObjectValues } from "@/utils/management/RenderObject";

export default function Counterparty() {
  const { t } = useTranslation();
  const globalValues = useAppSelector((state: any) => state);

  const keysToIgnore = [
    "id",
    "profile",
    "customer",
    "accountInformation",
    "intermediaryInformation",
  ];

  return (
    <ScrollView contentContainerClassName="flex-grow items-center px-4 py-2 bg-white1">
      <View className="w-full items-start">
        <Pressable
          onPress={() => {
            router.replace("/management/counterparties");
          }}
        >
          <AntDesign name="arrowleft" size={24} />
        </Pressable>
      </View>
      <View className="border border-gray rounded-lg p-6 w-full lg:w-3/5 shadow">
        <View className="w-full items-center mt-4">
          <TitleXl text={t("management/counterparties:counterparty.general")} />
        </View>
        {renderObjectValues(
          globalValues.counterpartyData ?? {},
          keysToIgnore,
          t,
        )}
        {renderObjectValues(
          globalValues.counterpartyData?.profile ?? {},
          ["address"],
          t,
        )}
        {renderObjectValues(
          globalValues.counterpartyData?.profile?.address ?? {},
          ["id"],
          t,
        )}
        <View className="w-full items-center mt-4">
          <TitleXl
            text={t("management/counterparties:counterparty.bankinformation")}
          />
        </View>
        {renderObjectValues(
          globalValues.counterpartyData?.accountInformation ?? {},
          ["institutionAddress", "id"],
          t,
        )}
        {renderObjectValues(
          globalValues.counterpartyData?.accountInformation
            .institutionAddress ?? {},
          ["id"],
          t,
        )}
      </View>
    </ScrollView>
  );
}
